import React, { useEffect, useState } from "react";
import {
  Col,
  ColType,
  Crud,
  CrudAction,
  CrudApi,
  CrudOption,
} from "../../comp/crud";
import { 
  IconCloudUploadStroked, 
  IconTickCircle,
  IconClose,
  IconList
} from "@douyinfe/semi-icons";
import { 
  Toast, 
  Modal, 
  Progress, 
  Typography, 
  Space,
  Button 
} from "@douyinfe/semi-ui";
import {ApiClient} from "../../api/ApiClient"

const { Text, Title } = Typography;

export default function LeadWarehouse() {
  const [importing, setImporting] = useState(false);
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [progressModalVisible, setProgressModalVisible] = useState(false);
  const [importProgress, setImportProgress] = useState({
    processedCount: 0,
    totalCount: 0,
    progress: 0,
    status: 'processing',
    message: ''
  });
  const [currentTaskId, setCurrentTaskId] = useState('');
    const [importLogModalVisible, setImportLogModalVisible] = useState(false);


const apiClient = ApiClient.getDefault();

let cols: Col[] = [
  {
    name: "手机号",
    key: "fullMobile",
    showInFilter: true,
    width: 100,
    type: ColType.STRING,
  },
  {
        name: "城市",
        key: "city",
        width: 50,
        type: ColType.SELECT,
        getOptions: () => apiClient.getDictAsOpts("city"),
        hideInEdit: true,
        hideInCreate: true,
        showInFilter: true,
  },
  // {
  //   name: "撞库渠道",
  //   key: "hitSource",
  //   showInFilter: true,
  //   width: 100,
  //   type: ColType.STRING,
  // },
  {
    name: "撞库时间",
    width: 100,
    showInFilter: true,
    key: "hitTime",
    type: ColType.DATE_RANGE,
  },
];
  const handleImportClick = () => {
    let input = document.createElement("input");
    input.type = "file";
    input.accept = ".xlsx";
    input.onchange = async () => {
      let file = input.files![0];
      if (!file) {
        return;
      }
      setImporting(true);
      setProgressModalVisible(true);
      try {
        // 上传文件并获取任务ID
        
      
        const resp = await apiClient.request<{ taskId: string }>(
          "/leadWarehouse/import",
          "POST",
          null,
          null,
          file
        );
        
        const taskId = resp.data.taskId;
        setCurrentTaskId(taskId);
        
        // 开始轮询进度
        startProgressPolling(taskId);
        
      } catch (e) {
        console.error("导入失败:", e);
        setImporting(false);
        setProgressModalVisible(false);
        Toast.error("导入失败");
      }
    };
    input.click();
  };

  const startProgressPolling = (taskId: string) => {
    const pollInterval = setInterval(async () => {
      try {
        const progressResp = await apiClient.request<any>(
          `/leadWarehouse/import/progress/${taskId}`,
          "GET"
        );
        
        const progressData = progressResp.data;
        setImportProgress({
          processedCount: progressData.processedCount || 0,
          totalCount: progressData.totalCount || 0,
          progress: progressData.progress || 0,
          status: progressData.status || 'processing',
          message: progressData.message || ''
        });

        // 如果任务完成，停止轮询
        if (progressData.status === 'completed' || progressData.status === 'failed') {
          clearInterval(pollInterval);
          setImporting(false);
          
          if (progressData.status === 'completed') {
            Toast.success(`导入完成！成功导入 ${progressData.processedCount} 个客户`);
            crudApi?.refresh();
            // 3秒后自动关闭进度弹窗
            // setTimeout(() => {
            //   setProgressModalVisible(false);
            // }, 3000);
          } else {
            Toast.error(`导入失败: ${progressData.message}`);
          }
        }
      } catch (e) {
        console.error("获取进度失败:", e);
        // 出错时也停止轮询
        clearInterval(pollInterval);
        setImporting(false);
        Toast.error("获取导入进度失败");
      }
    }, 1000); // 每秒轮询一次
  };

  const getStatusIcon = () => {
    switch (importProgress.status) {
      case 'completed':
        return <IconTickCircle style={{ color: 'var(--semi-color-success)' }} />;
      case 'failed':
        return <IconClose style={{ color: 'var(--semi-color-danger)' }} />;
      default:
        return <IconCloudUploadStroked style={{ color: 'var(--semi-color-primary)' }} />;
    }
  };

  const getStatusText = () => {
    switch (importProgress.status) {
      case 'completed':
        return '导入完成';
      case 'failed':
        return '导入失败';
      default:
        return '导入中...';
    }
  };

  const handleImportLogClick = () => {
    setImportLogModalVisible(true);
  };

  const importLeadsAction: CrudAction = {
    name: "导入客户",
    action: handleImportClick,
    loading: importing,
    icon: <IconCloudUploadStroked />,
  };

  const importLeadLogsAction: CrudAction = {
    name: "导入日志",
    action: handleImportLogClick,
    icon: <IconList />,
  };

  const actions: CrudAction[] = [importLeadsAction, importLeadLogsAction];

  return (
    <>
      <Crud
        canUpdate={false}
        canCreate={false}
        actions={actions}
        name="客户底库"
        entityKey="leadWarehouse"
        pageSize={50}
        rowActionWidth={30}
        cols={cols}
      />
      
      <Modal
        title="导入进度"
        width={600}
        height={300}
        visible={progressModalVisible}
        footer={
          <Button 
            onClick={() => setProgressModalVisible(false)}
            disabled={importProgress.status === 'processing'}
          >
            {importProgress.status === 'processing' ? '处理中...' : '关闭'}
          </Button>
        }
        closable={importProgress.status !== 'processing'}
        onCancel={() => {
          if (importProgress.status !== 'processing') {
            setProgressModalVisible(false);
          }
        }}
      >
        <Space vertical align="start" style={{ width: '100%' }} spacing={16}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {getStatusIcon()}
            <Text strong>{getStatusText()}</Text>
          </div>
          
          <div style={{ width: '100%' }}>
            <Progress 
              percent={importProgress.progress} 
              showInfo={true}
              stroke={
                importProgress.status === 'failed' ? 
                'var(--semi-color-danger)' : 
                'var(--semi-color-primary)'
              }
            />
          </div>
          
          <div style={{ width: '100%' }}>
            <Text style={{ fontSize: 18, fontWeight:30, color: 'var(--semi-color-text-0)' }}>
              进度: {importProgress.processedCount} / {importProgress.totalCount} 
              ({importProgress.progress}%)
            </Text>
          </div>
          
          {importProgress.message && (
            <div style={{ width: '100%' }}>
              <Text type="secondary">{importProgress.message}</Text>
            </div>
          )}
        </Space>
      </Modal>

      <Modal
        title="导入日志"
        width={1200}
        height={600}
        visible={importLogModalVisible}
        onCancel={() => {
            setImportLogModalVisible(false);
          
        }}
      >
           <Crud
            canUpdate={false}
            canCreate={false}
            name="导入日志"
            entityKey="leadWarehouse/import/logs"
            pageSize={50}
            rowActionWidth={30}
            cols={[
              { name: "导入时间", key: "createdAt", type: ColType.DATE },
              { name: "导入人", key: "req", type: ColType.STRING, showInFilter: true },
              { name: "导入结果", key: "resp", type: ColType.STRING, width: 400 },
              { name: "导入城市", key: "url", type: ColType.STRING, showInFilter: true },
             
            ]}
            />
      </Modal>
    </>
  );
}